import React from 'react'
import './Projects.css'
export default function ProjectsHero() {
    return (
      <div className="project-hero">
        <div className="overlay-text">
            <p className='subheading' id="project-details" style={{marginTop: '1em'}}>
              Projects
          </p>
        </div>
      </div>
      );
}
